module.exports = __webpack_public_path__ + "img/pc-message.06dfbe61.svg";